import "./XAxisTick.css";

// Custom tick renderer for angled X axis labels with extra space
export const XAxisTick: React.FC<{
    x?: number;
    y?: number;
    payload?: { value: string | number };
}> = ({ x = 0, y = 0, payload = { value: "" } }) => (
    <g transform={`translate(${x},${y + 8})`}>
        <text
            x={0}
            y={12}
            dy={0}
            textAnchor="end"
            fill="var(--ds-color-neutral-text-subtle)"
            fontSize={"var(--ds-font-size-1)"}
            transform="rotate(-60)"
        >
            {payload.value}
        </text>
    </g>
);
